<template>
  <div class="payment">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <!-- <el-switch
          v-model="rechargeLimitFlag"
          active-text="最低充值50开启"
          inactive-text="最低充值50关闭"
          @change="rechargeLimit"
        ></el-switch> -->
        <el-button size="small" type="primary" @click="openDialog"
          >支付控制</el-button
        >
      </el-form-item>
      <el-form-item label="选择设备">
        <el-select
          v-model="query.show_type"
          @change="getData(1)"
          placeholder="请选择设备"
        >
          <el-option :value="undefined">全部</el-option>
          <el-option :value="2" label="仅电脑显示"></el-option>
          <el-option :value="3" label="仅手机显示"></el-option>
          <el-option :value="1" label="电脑手机都显示"></el-option>
          <el-option :value="0" label="不显示"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择分组">
        <el-select
          v-model="query.category_id"
          placeholder="请选择支付分组"
          @change="getData(1)"
        >
          <el-option :value="undefined">全部</el-option>
          <el-option
            v-for="item in groupsList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table :data="dataList" v-loading="loading">
      <el-table-column prop="id" label="ID" width="60px"></el-table-column>
      <el-table-column prop="show_name" label="后台支付名称"></el-table-column>
      <el-table-column prop="name" label="后台名称"></el-table-column>
      <el-table-column label="支付类型">
        <template slot-scope="scope">
          <el-tag type="primary" v-if="scope.row.pay_type == 1">支付宝</el-tag>
          <el-tag type="success" v-else>微信</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="image" label="支付图标">
        <template slot-scope="{ row }">
          <img style="width: 30px" :src="row.image" alt="" />
        </template>
      </el-table-column>
      <el-table-column prop="unchecked_image" label="未选中图标">
        <template slot-scope="{ row }">
          <img style="width: 30px" :src="row.unchecked_image" alt="" />
        </template>
      </el-table-column>
      <el-table-column label="前端展示">
        <template slot-scope="{ row }">
          <span>{{ row.payment_category && row.payment_category.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="probability" label="分组概率">
        <template slot-scope="{ row }">
          <span>{{ row.probability}}%</span>
        </template>
      </el-table-column>
      <el-table-column label="支付开关">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_open == 1">开</el-tag>
          <el-tag type="info" v-else>关</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="时段开关">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_time_switch == 1"
            >开</el-tag
          >
          <el-tag type="info" v-else>关</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="显示设备">
        <template slot-scope="scope">
          <span v-if="scope.row.show_type === 0">不显示</span>
          <span v-if="scope.row.show_type === 1">电脑手机都显示</span>
          <span v-if="scope.row.show_type === 2">仅电脑显示</span>
          <span v-if="scope.row.show_type === 3">仅手机显示</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="支付权重"> </el-table-column>
      <el-table-column prop="single_max_amount" label="单笔最大金额">
      </el-table-column>
      <el-table-column prop="day_max_amount" label="每日最大金额">
      </el-table-column>
      <el-table-column prop="hour_max_amount" label="每时最大金额">
      </el-table-column>
      <el-table-column label="操作" width="160px">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="dataMeta ? dataMeta.per_page : 20"
      :total="dataMeta ? dataMeta.total : 0"
      :current-page="query.page"
      @current-change="handlePageChange"
      v-if="dataMeta && dataMeta.total > dataMeta.per_page"
    ></el-pagination>
    <!-- 弹窗 -->
    <!-- 支付控制弹窗 -->
    <PaymentControl
      :visible="visibleControl"
      v-model="controlInfo"
      @close="visibleControl = false"
    ></PaymentControl>
    <!-- 编辑支付弹窗 -->
    <PaymentEdit
      :visible="visibleEdit"
      @close="visibleEdit = false"
      @refresh="getData"
      :id="currentId"
      :defaultValues="defaultValues"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import http, { getApiData, api, delData } from '@/http.js'
import PaymentEdit from '@/components/payment/PaymentEdit'
import PaymentControl from '@/components/payment/PaymentControl'
import PaymentSetting from '@/components/payment/PaymentSetting'
export default {
  components: {
    PaymentEdit,
    PaymentSetting,
    PaymentControl,
  },
  data() {
    return {
      activeName: 'all',
      loading: false,
      visibleControl: false,//支付控制弹窗显示标志
      visibleEdit: false,//编辑弹窗显示标志
      defaultValues: undefined,
      currentId: undefined,
      dataList: undefined,//数据列表
      controlInfo: undefined,//支付控制弹窗数据
      rechargeLimitFlag: false,//充值限制标志 false是关 true是开
      query: {
        page: 1,
        show_type: undefined,
        category_id: undefined
      },
      groupsList: undefined,//分组列表
      dataMeta: undefined,//底部分页数据
    }
  },
  computed: {
    ...mapState({
    })
  },
  created() {
    this.getData()
    this.getRechargeLimit()
    this.getGroups()//获取分组
  },
  methods: {
    ...mapActions(['getPaymentList', 'getPaymentSetting']),
    getGroups() {
      //获取分组列表
      getApiData(`pay_category`)
        .then(
          res => {
            this.groupsList = res
          }
        )
    },
    getData() {
      //获取数据列表
      this.loading = true
      let params = this.query
      getApiData(`pay_configs`, params).then(res => {
        this.dataList = res
        this.dataMeta = res
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    openDialog() {
      //打开控制弹窗
      this.visibleControl = true
    },
    handleEdit(rowInfo) {
      this.visibleEdit = true
      this.currentId = rowInfo.id
      this.defaultValues = JSON.parse(JSON.stringify(rowInfo))
    },
    timeConfigToArr(config) {
      let arr = []
      let obj = JSON.parse(config)
      for (let key in obj) {
        arr.push(obj[key])
      }
      return arr
    },
    getRechargeLimit() {
      //获取充值限制开关状态
      getApiData('minimum_recharge').then(res => {
        this.rechargeLimitFlag = res.data
      })
    },
    rechargeLimit() {
      //修改充值限制开关状态
      let params = {
        black: this.rechargeLimitFlag
      }
      patchApiData('minimum_recharge', params)
        .then(
          res => {
            if (res) {
              this.$message.success('操作成功！')
            }
          }
        )
        .finally(() => {
        })
    },
  }
}
</script>
